import GatewayContainer from '../config/GatewayContainer';
import GatewayNames from '../constant/GatewayNames';
import EnrichmentClient from '../client/enrichment/EnrichmentClient';
import { ActionType } from '../constant/Constants';
import { BulkActionDependencyError } from 'redux/reducers/BulkActionReducer';

class EnrichmentService {
  private enrichmentClient: EnrichmentClient = GatewayContainer.getInstance().get(GatewayNames.ENRICHMENT_CLIENT);

  public async bulkAction(ids: string[], type: ActionType): Promise<BulkActionDependencyError[]> {
    const logs: any = await this.enrichmentClient.bulkAction(ids, type);
    return logs;
  }
}

export default EnrichmentService;
